import { render, staticRenderFns } from "./capture-video.vue?vue&type=template&id=5f357bc2&scoped=true"
import script from "./capture-video.vue?vue&type=script&lang=js"
export * from "./capture-video.vue?vue&type=script&lang=js"
import style0 from "./capture-video.vue?vue&type=style&index=0&id=5f357bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f357bc2",
  null
  
)

export default component.exports